import { createFileRoute } from "@tanstack/react-router";
import { ExplorePage } from "@/features/explore/ExplorePage";
import { loadPublic } from "@/lib/guards";

export const Route = createFileRoute("/explore")({
  beforeLoad: loadPublic,
  component: ExplorePage,
});
